export default {
    methods: {
        criarColunas(
            textArray = [],
            valueArray = [],
            sortableArray = [],
            alignArray = [],
            widthArray = [],
            classe = null,
            formatterArray = []
        ) {
            let colunas = []
            for (let i = 0; i < textArray.length; i++) {
                let coluna = {
                    text: textArray.length > 0 ? textArray[i] : null,
                    value: valueArray.length > 0 ? valueArray[i] : null,
                    sortable: sortableArray.length > 0 ? sortableArray[i] : null,
                    align: alignArray.length > 0 ? alignArray[i] : null,
                    width: widthArray.length > 0 ? widthArray[i] : null,
                    class: classe,
                    formatter: formatterArray.length > 0 ? formatterArray[i] : null
                }
                colunas.push(coluna)
            }
            return colunas
        }
    }
}
